import { useState, useEffect } from 'react'
import { CircularProgress, TextField, Autocomplete, Typography } from '@mui/material'

import { ChevronDownIcon } from '@/assets/icons/chevron-icons'

const appID = import.meta.env.VITE_SCHOOLDIGGER_APP_ID
const appKey = import.meta.env.VITE_SCHOOLDIGGER_APP_KEY

function SchoolSearch({ value, setValue }) {
  const [searchTerm, setSearchTerm] = useState('')
  const [results, setResults] = useState([])
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [noMatches, setNoMatches] = useState(false)
  const [selectedNoSchool, setSelectedNoSchool] = useState(false)

  useEffect(() => {
    let timerId

    if (searchTerm) {
      setLoading(true)
      timerId = setTimeout(() => {
        const encodedSearchTerm = encodeURIComponent(searchTerm)
        const url = `https://api.schooldigger.com/v2.0/autocomplete/schools?appID=${appID}&appKey=${appKey}&q=${encodedSearchTerm}&qSearchCityStateName=true&returnCount=20`

        fetch(url)
          .then(async response => {
            const res = await response.json()

            setLoading(false)
            if (res.schoolMatches.length === 0 || !res.schoolMatches) {
              setNoMatches(true)
              setResults([])

              return
            }
            const schools = res.schoolMatches.map(school => ({
              ...school,
              value: school.schoolid,
              label: `${school.schoolName} | ${school.city}, ${school.state}`,
            }))

            schools.push({
              schoolName: null,
              schoolid: null,
              value: null,
              label: "I don't see my school on this list",
            })
            setNoMatches(false)
            setResults(schools || [])

            return res
          })
          .catch(error => console.error(error))
      }, 500)
    }

    return () => clearTimeout(timerId)
  }, [searchTerm])

  const handleSelectNoSchool = () => {
    setSelectedNoSchool(true)
    setOpen(false)
    setNoMatches(false)
    setResults([])
    setSearchTerm('')
    setValue({
      schoolName: '',
      schoolid: '',
    })
  }

  return (
    <Autocomplete
      fullWidth
      filterOptions={x => x}
      getOptionLabel={option =>
        option?.schoolName
          ? `${option.schoolName} | ${option.city}, ${option.state}`
          : "I don't see my school on this list"
      }
      inputValue={searchTerm}
      loading={loading}
      noOptionsText={
        noMatches ? (
          <>
            {/* <MenuItem color="secondary">+ Add School</MenuItem> */}
            <Typography color="text.secondary" onClick={handleSelectNoSchool}>
              {' '}
              I don't see my school on this list
            </Typography>
          </>
        ) : (
          'Start typing to search...'
        )
      }
      open={open}
      options={results || []}
      popupIcon={<ChevronDownIcon style={{ color: '#667085' }} width={20} />}
      renderInput={params => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          placeholder="Search for your school"
          size="small"
          variant="outlined"
        />
      )}
      sx={{
        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '8px !important',
        },
        '& .MuiInputBase-root': {
          height: '44px !important',
        },
      }}
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue)
      }}
      onClose={() => {
        setOpen(false)
      }}
      onInputChange={(event, newInputValue) => {
        setSearchTerm(newInputValue)
      }}
      onOpen={() => {
        setOpen(true)
      }}
    />
  )
}

export default SchoolSearch

//
// create function to quert this endpoint and return the school objectwith the school id

//https://api.schooldigger.com/v2.0/schools?appID=(your_app_id)&appKey=(your_app_key)&schoolID=530771001146
export const getSchoolData = async schoolID => {
  try {
    const url = `https://api.schooldigger.com/v2.0/schools/${schoolID}?appID=${appID}&appKey=${appKey}`
    const response = await fetch(url)
    const data = await response.json()

    return data
  } catch (error) {
    return {
      district: {
        districtID: null,
        districtName: null,
      },
    }
  }
}

export const getAllSchoolsInDistrict = async (districtID, state) => {
  try {
    const url = `https://api.schooldigger.com/v2.0/schools?appID=${appID}&appKey=${appKey}&st=${state}&districtID=${districtID}`
    const response = await fetch(url)
    const data = await response.json()

    return data
  } catch (error) {
    return null
  }
}
